import { mapToSelect } from "@api/egm";
import RefreshButton from "@buttons/RefreshButton";
import React from "react";
import { connect } from "react-redux";
import { Form, Select } from "semantic-ui-react";

const CollectionWeekFilters = (props) => {
  const { onChange, view, filters } = props;
  const { periods, searchParams } = view;
  const { hasSelection } = filters;
  const { week } = searchParams;

  return (
    <Form.Group>
      <Form.Field inline>
        <label style={{ width: "50px" }}>Week:</label>
        <Select
          name="week"
          options={mapToSelect(periods)}
          onChange={(e, { name, value }) => onChange(name, value)}
          value={week}
          disabled={periods.length < 1}
          search
        />
      </Form.Field>
      <RefreshButton refresh={props.refresh} disabled={!hasSelection} />
    </Form.Group>
  );
};

const mapStateToProps = (state) => {
  return {
    logIn: state.logIn,
    filters: state.transactionsFilters,
    view: state.transactionsView,
  };
};

export default connect(mapStateToProps, null)(CollectionWeekFilters);
